import React from 'react';
import './estilo.css';

function Rodape(){
    return(
        <footer className='rodape'>
            <div className='texto-rodape'>
                &copy; Copyright 2024 | Clínica Dentes Saudáveis
            </div>
        </footer>
    );
}

export default Rodape;